module.exports = __webpack_public_path__ + "img/bagy.45cab2b6.webp";